import React, { FunctionComponent } from 'react';
import {
  HScroll, Badge, BadgeColor, Image,
} from '@doveit/lego';

import Highlights from '../../../components/highlights/Highlights';

import * as styles from './ListingHeader.style';

export const DEFAULT_DATA_REF = 'listing-header';

export interface ListingHeaderProps {
  title: string,
  status?: string,
  subtitle?: string,
  price: string,
  logo?: string,
  highlights: string[],
  dataRef?: string,
}

const ListingHeader: FunctionComponent<ListingHeaderProps> = ({
  title,
  status,
  subtitle,
  price,
  logo,
  highlights,
  dataRef = DEFAULT_DATA_REF,
}) => (
  <div data-ref={dataRef}>
    <h1 css={styles.title} data-ref={`${dataRef}-title`}>
      {title}
    </h1>
    {status && (
      <div css={styles.status}>
        <Badge
          text={status}
          color={BadgeColor.SECONDARY}
        />
      </div>
    )}
    {subtitle && (
      <h2 css={styles.subtitle} data-ref={`${dataRef}-subtitle`}>
        {subtitle}
      </h2>
    )}
    <HScroll>
      <div css={styles.highlightsWrapper}>
        <Highlights items={highlights} />
      </div>
    </HScroll>
    {logo && (
      <div css={styles.logo}>
        <Image
          src={logo}
          alt={logo}
          height="30px"
        />
      </div>
    )}
    <h3 css={styles.price} data-ref={`${dataRef}-price`}>
      {price}
    </h3>
  </div>
);

export default ListingHeader;
